<template>
    <div class="inputs-container">
        <div class="code-message-container">
            <div class="code-text">
                <p>Digite o código <span class="code-number">{{ generatedCode }}</span> para confirmar</p>
            </div>
        </div>
        <div class="code-input-container">
            <input
                v-for="(digit, index) in code"
                :key="index"
                ref="inputs"
                v-model="code[index]"
                v-mask="'#'"
                maxlength="1"
                max="1"
                type="number"
                class="code-input"
                :class="{ 'error-state': errorHandle }"
                @input="handleInput(index)"
                @keydown.delete="handleDelete(index)"
            />
            <ui-circle-v v-if="valideHandle" :design="'ml4px'"/>
            <ui-circle-x v-if="errorHandle" :design="'ml4px'"/>
        </div>
        <div v-if="isWarningText">
            <div class="warn-text">
                <span class="code-text-weight">Atenção: <span class="code-text">Essa ação não poderá ser desfeita.</span></span>
            </div>
        </div>
        
    </div>
</template>

<script>
    import { mask } from 'vue-the-mask'

    export default {
        name: 'ui-code-confirm',

        directives: {
            mask
          },

        props: {
            // name para dar para o componente ficar unico Ex: "modal-login", "reset-senha"
            codeName: {
                type: String,
                required: false,
                default: '', 
            },
            isWarningText: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        
          data() {
            return {
                code: ["", "", "", ""],
                generatedCode: "",
                errorHandle: false,
                valideHandle: false
            }
        },
        
        watch: {
            code: {
                handler() {
                    this.validateCode();
                },
                deep: true
            },
        },
        mounted() {
            this.generateCode()
        },

        methods: {
            validateCode() {
                const codeString = this.code.join("");

                if (codeString.length < 4) {
                    this.disableButtonHandler = true;
                    this.errorHandle = false;
                    this.valideHandle = false;
                    this.$emit('code-validated', {
                        name: this.codeName,
                        isValid: false
                    });                    
                    return;
                }

                if (codeString === this.generatedCode) {
                    this.disableButtonHandler = false;
                    this.errorHandle = false;
                    this.valideHandle = true;
                    this.$emit('code-validated', {
                        name: this.codeName,
                        isValid: true
                    });
                } else {
                    this.disableHandler = true;
                    this.errorHandle = true;
                    this.valideHandle = false;
                    this.$emit('code-validated', {
                        name: this.codeName,
                        isValid: false
                    });
                }
            },

            handleInput(index) {
                if (this.code[index] && index < this.code.length - 1) {
                    this.$refs.inputs[index + 1].focus();
                }
            },
            handleDelete(index) {
                if (!this.code[index] && index > 0) {
                    this.$refs.inputs[index - 1].focus();
                }
            },

            generateCode() {
                this.generatedCode = "";
                for (let i = 0; i < 4; i++) {
                    this.generatedCode += Math.floor(Math.random() * 10);
                }
            },
            resetCode() {
                this.code = ["", "", "", ""];
                this.generateCode();
                this.errorHandle = false;
                this.valideHandle = false;
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>